// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__zyBy6","closeModalIcon":"PopUpModal_closeModalIcon__ydBWu"};